<div class="data-source-picker">
  <button class="upload-btn" (click)="toggleMenu($event)">
    <img src="assets/icons/Plus-blue.svg" alt="Add" class="upload-icon">
  </button>

  <div class="datasource-dropdown" [class.open-to-left]="openToLeft" *ngIf="menuOpen">
    <button class="dropdown-item" *ngIf="allowUploadFile" (click)="onUploadFile()">
      <mat-icon svgIcon="upload_file"></mat-icon>
      <div class="dropdown-label">
        <span class="label">{{ uploadLabel }}</span>
        <span class="dropdown-item-desc">{{ uploadDescription }}</span>
      </div>
      <mat-icon *ngIf="showInfoIcon" class="info-icon" svgIcon="info" matTooltip="Temporarily upload a file for one-time analysis. The data is not stored in the system."></mat-icon>
    </button>
    <button class="dropdown-item" *ngIf="allowDataSourceSelection" (click)="onSelectExisting()">
      <mat-icon [svgIcon]="dataSourceIcon"></mat-icon>
      <div class="dropdown-label">
        <span class="label">Select Existing Datasource</span>
        <span class="dropdown-item-desc">Use a saved datasource from your account</span>
      </div>
    </button>
    <button class="dropdown-item" *ngIf="allowDataSourceSelection && allowCreateNew" (click)="onCreateNew()">
      <mat-icon svgIcon="plus-blue"></mat-icon>
      <div class="dropdown-label">
        <span class="label">Create New Datasource</span>
        <span class="dropdown-item-desc">Connect to create a reusable datasource</span>
      </div>
    </button>
  </div>

  <div class="datasource-dropdown datasource-list-view" [class.open-to-left]="openToLeft" *ngIf="listOpen">
    <button class="dropdown-item back-button" (click)="backToMenu()">
      <mat-icon svgIcon="arrow_back"></mat-icon>
      <span>Back</span>
    </button>
    <div class="datasource-search-container">
      <mat-form-field appearance="outline" class="datasource-search-field">
        <mat-icon matPrefix svgIcon="search"></mat-icon>
        <input matInput [(ngModel)]="searchQuery" placeholder="Search data sources..." (click)="$event.stopPropagation()">
      </mat-form-field>
    </div>
    <div class="datasource-list">
      <button class="dropdown-item datasource-item"
              [class.selected]="isSelected(dataSource)"
              *ngFor="let dataSource of filteredDataSources"
              (click)="onDataSourceSelect(dataSource)">
        <mat-icon [svgIcon]="dataSourceIcon"></mat-icon>
        <span>{{ dataSource.dataSourceName }}</span>
        <mat-icon *ngIf="isSelected(dataSource)" class="check-icon" [svgIcon]="checkIcon"></mat-icon>
      </button>
      <div *ngIf="filteredDataSources.length === 0">
        <div class="no-results" *ngIf="!isLoadingDataSources">No data sources found</div>
        <div class="loading-dropdown" *ngIf="isLoadingDataSources">
          <mat-spinner diameter="24"></mat-spinner>
          <div class="loading-text">Loading data sources...</div>
        </div>
      </div>
    </div>
  </div>
</div>
